import { Loader } from '@googlemaps/js-api-loader';

const GoogleMapsApiLoader = new Loader({
  apiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY || '',
  version: 'quarterly',
  libraries: ['places', 'geocoding'],
});

export default GoogleMapsApiLoader;